export default {
  "content": "<path fill=\"#707070\" fill-rule=\"evenodd\" d=\"M9.75 0h.75c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5h-9A1.5 1.5 0 010 10.5v-9A1.5 1.5 0 011.5 0h8.25zM1.5 10.5h9V3.75h-9v6.75zm2.25-3a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "14",
    "fill": "none",
    "viewBox": "0 0 12 12"
  }
};